import { hint } from 'ui.vue3.directives.hint';
import { BIcon as UiIcon, Set as IconSet } from 'ui.icon-set.api.vue';

import './full-form.css';

// @vue/component
export const FullForm = {
	name: 'ActionsPopupFullForm',
	components: {
		UiIcon,
	},
	directives: {
		hint,
	},
	props: {
		bookingId: {
			type: Number,
			required: true,
		},
	},
	computed: {
		arrowIcon(): string
		{
			return IconSet.CHEVRON_RIGHT;
		},
		arrowIconSize(): number
		{
			return 12;
		},
		arrowIconColor(): string
		{
			return 'var(--ui-color-palette-gray-40)';
		},
		soonHint(): Object
		{
			return {
				text: this.loc('BOOKING_BOOKING_SOON_HINT'),
				popupOptions: {
					offsetLeft: 60,
				},
			};
		},
	},
	template: `
		<div
			v-hint="soonHint"
			class="booking-actions-popup__item booking-actions-popup__item-full-form-content --disabled"
			role="button"
			tabindex="0"
		>
			<div class="booking-actions-popup__item-full-form-label">
				{{ loc('BB_ACTIONS_POPUP_FULL_FORM_LABEL') }}
			</div>
			<div class="booking-actions-popup__item-full-form-icon">
				<UiIcon :name="arrowIcon" :size="arrowIconSize" :color="arrowIconColor"/>
			</div>
		</div>
	`,
};
